var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('span',{style:(`--i: 0; background-color: ${_vm.color}`)}),_c('span',{style:(`--i: 1; background-color: ${_vm.color}`)}),_c('span',{style:(`--i: 2; background-color: ${_vm.color}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }